const meta = {
  DEFAULT_TITLE:  "VCP Gau Alt-Burgund",
  DEFAULT_DESCRIPTION: "Website des Gau Alt-Burgunds im Verband christlicher Pfadfinderinnen und Pfadfinder (VCP)"

};

export default meta;
